<template>
  <PopupBase
    @close-pop-up="closePopUp"
    class="simmerring-selector-disclaimer"
    v-bind="$attrs"
  >
    <div class="simmerring-selector-disclaimer__content">
      <h3>
        {{ $tv('disclaimerHeadline', 'simmerringSelector') }}
      </h3>
      <Markdown
        :text="$tv('disclaimerText', 'simmerringSelector')"
      />
      <div class="simmerring-selector-disclaimer__actions">
        <Checkbox
          :label="$tv('disclaimerCheckboxLabel', 'simmerringSelector')"
          @change="acceptedDisclaimer = !acceptedDisclaimer"
          :disabled="!checkboxReady"
        />
        <ReactiveButton
          :button-text="$tv('accept', 'simmerringSelector')"
          :disabled="!acceptedDisclaimer"
          @click="closePopUp"
        />
      </div>
    </div>
  </PopupBase>
</template>

<script setup lang="ts">
import PopupBase from './PopupBase.vue'
import Checkbox from '~/components/input-components/Checkbox'
import ReactiveButton from '~/components/ReactiveButton'
import {IS_WIDGET} from '~/widgets/shared/widget-config'
import {useConfigurationDataStore} from '~/store/configuration-data'

const isWidget = inject(IS_WIDGET, false)

const props = defineProps<{
  onWidgetAccept?: () => void
}>()

const acceptedDisclaimer = ref(false)
const checkboxReady = ref(false)

const closePopUp = () => {
  if (isWidget && props.onWidgetAccept) {
    props.onWidgetAccept()
  } else {
    useConfigurationDataStore().acceptedSimmerringSelectorDisclaimer = acceptedDisclaimer.value
  }
}

onMounted(() => {
  checkboxReady.value = true
})

</script>

<style lang="scss">
.simmerring-selector-disclaimer {
  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;

    @include breakpoint-down($hydraulicDisclaimer) {
      label.k-checkbox-label > span {
        width: calc(100% - 2rem);
        display: inline-block;
      }
    }

    h3 {
      margin: 0;
    }
  }

  &__actions {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    @include breakpoint-down($hydraulicDisclaimer) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .popup > .popup__wrapper > .popup__content > .close {
    display: none;
  }
}

body:has(.simmerring-selector-disclaimer.popup--visible) {
  overflow: hidden;
}
</style>
